// TextConstants.js
import Immutable        from 'immutable';
import constants from 'Constants.js';
import listService from 'ListService';

//==============================================================================
//
//  Text constants singleton.
//
//==============================================================================
class TextConstants {
    constructor() { }

//DELETE PAGE MODAL
    get EDITOR_DELETE_PAGE_TITLE() { return 'Delete'; }
    get EDITOR_DELETE_PAGE_TEXT() { return 'You have deleted a page. <br /><br /> This action can be undone by selecting the menu item Edit | Undo.'; }
    get EDITOR_DELETE_PAGE_CHECKBOX_TEXT() { return "Don't show this message again"; }
    get EDITOR_DESIGN() { return 'Design App'; }
    get EDITOR_DESIGN_OPENED_BY_OTHER_USER() { return ' An error has ocurred. <br /><br /> The app or report is already being edited by another user.'; }

    get UNDO_NEW() { return 'New';}
    get UNDO_MOVE() {return 'Move';}
    get UNDO_RESIZE() {return 'Resize';}
    get UNDO_PROP_CHANGE() {return 'Property Change';}
    get UNDO_FORM_CHANGE() {return 'App Property Change';}
    get UNDO_PAGE_CHANGE() {return 'Page Property Change';}
    get UNDO_DELETE() {return 'Delete';}
    get UNDO_PASTE() {return 'Paste';}
    get UNDO_CUT() {return 'Cut';}
    get UNDO_PASTE_MULTIPLE() {return 'Paste Multiple Controls';}
    get UNDO_DELETE_MULTIPLE() {return 'Delete Multiple Controls';}
    get UNDO_ADD_GROUP() {return 'Add Group';}
    get UNDO_REMOVE_GROUP() {return 'Remove Group';}
    get UNDO_NEW_ROLE() {return 'New Role';}
    get UNDO_DELETE_ROLE() {return 'Delete Role';}
    get UNDO_NEW_BEHAVIOR() {return 'New Behavior';}
    get UNDO_EDIT_ROLE() {return 'Edit Role';}
    get UNDO_NEW_PAGE() {return 'New Page';}
    get UNDO_NEW_USER_POSITION(){return 'New User Position'}
    get UNDO_MANDATORY(){return 'Mandatory'}
    get UNDO_MANDATORY_CHECK(){return 'Mandatory Check'}
    get UNDO_POSITION(){return 'Position'}
    get UNDO_ACCESS_DESCRIPTION(){return 'Description'}
    get UNDO_ACCESS_STATE(){return 'State'}
    get UNDO_TABBING(){return 'Tabbing'}
    get UNDO_TABBING_CHECK(){return 'Tabbing Check'}
    get UNDO_ROW_COLOR(){return 'Row Color'}
    get UNDO_BORDER(){return 'Border'}
    get UNDO_BORDER_SELECTION(){return 'Border Option Choose'}
    get UNDO_COLOR_BORDER(){return 'Border Color'}
    get UNDO_COLOR_HEADER_BACKGROUND(){return 'Header Background Color'}
    get UNDO_COLOR_HEADER_TEXT(){return 'Header Text Color'}
    get UNDO_HEADER_STYLE(){return 'Header Style'}



    get UNDO_NEW_USER() {return 'New User';}
    get UNDO_NEW_USER_GROUP() {return 'New User Group';}
    get UNDO_NEW_CONNECTION() {return 'New Connection';}
    get UNDO_NEW_ACTION() {return 'New Action';}
    get UNDO_NEW_EMAIL_SVR() {return 'New Email-Server';}
    get UNDO_NEW_LIST() {return 'New List';}
    get UNDO_UPDATE_CONNECTION() {return 'Update Connection';}
    get UNDO_UPDATE_ACTION() {return 'Update Action';}
    get UNDO_NEW_FORM() {return 'New App';}
    get UNDO_UPDATE_FORM() {return 'Update App';}
    get UNDO_DELETE_FORM() {return 'Delete App';}
    get UNDO_DELETE_CONNECTION() {return 'Delete Connection';}
    get UNDO_DELETE_ACTION() {return 'Delete Action';}
    get UNDO_UPDATE_REPORT() {return 'Update Report';}
    get UNDO_DELETE_REPORT() {return 'Delete Report';}
    get UNDO_UPDATE_SYNCHRONIZATION() {return 'Update Synchronization';}
    get UNDO_NEW_REPORT() {return 'New Report';}
    get UNDO_UPDATE_ACCOUNT() {return 'Update Account';}
    get UNDO_UPDATE_EMAIL_SVR() {return 'Update Email-Server';}
    get UNDO_UPDATE_LIST() {return ' Update List';}
    get UNDO_UPDATE_PERSONAL_DETAILS() {return 'Update Personal Details';}
    get UNDO_DELETE_USER() {return 'Delete User';}
    get UNDO_UPDATE_USER() {return 'Update User';}
    get UNDO_UPDATE_USER_GROUP() {return 'Update User Group';}
    get UNDO_ALIGN_RIGHT() {return 'Align Right';}
    get UNDO_ALIGN_LEFT() {return 'Align Left';}
    get UNDO_ALIGN_TOP() {return 'Align Top';}
    get UNDO_ALIGN_BOTTOM() {return 'Align Bottom';}
    get UNDO_NEW_FORM_FOLDER() {return 'New Folder';}
    get UNDO_DELETE_FORM_FOLDER() {return 'Delete App Folder';}
    get UNDO_DELETE_REPORT_FOLDER() {return 'Delete Report Folder';}
    get UNDO_SHARE_FORM() {return 'Share App';}
    get UNDO_SHARE_REPORT() {return 'Share Report';}
    get UNDO_DELETE_CUSTOM_LIST() {return 'Delete Custom List';}
    get UNDO_DELETE_USER_GROUP() {return 'Delete User Group';}
    get UNDO_DELETE_POSITION() {return 'Delete Position';}
    get UNDO_DELETE_CUSTOM_LIST() {return 'Delete Custom List';}
    get UNDO_DELETE_EMAIL_SERVER() {return 'Delete Email Server';}
    get UNDO_DELETE_INSTANCE() {return 'Delete App Instance';}

    get UNDO_CHANGE_TITLE() {return 'Change Title';}
    get UNDO_EDIT_VALUE() {return 'Edit Value';}
    get UNDO_CUSTOM_PARAMETER() {return 'Custom Parameter';}
    get UNDO_SELECT_OBJECT() {return 'Select Object';}
    get UNDO_RENAME_FOLDER() {return 'Rename Folder';}
    get UNDO_RENAME_FORM() {return 'Rename App';}
    get UNDO_RENAME_REPORT() {return 'Rename Report';}
    get UNDO_FORM_FAVORITES() {return 'App Favorites';}

    //Features
    get WEB_SIGNATURE_FEATURE_NOT_ENABLED_TITLE() { return 'Web Signature'; } 
    get WEB_SIGNATURE_FEATURE_NOT_ENABLED_TEXT() { return 'The Web Signature feature is not enabled on your account.<br /><br />Contact ' + listService.salesEmailAddress + ' for more information.'; }
    get GOOGLE_CONNECTIONS_FEATURE_NOT_ENABLED_TITLE() { return 'Google Spreadsheet Connections'; }
    get GOOGLE_CONNECTIONS_FEATURE_NOT_ENABLED_TEXT() { return 'The Google Spreadsheet Connections feature is not enabled on your account. Contact ' + listService.salesEmailAddress + ' for more information.'; }

    get USER_SESSION_TIMEOUT() { return 'The current session has timed out. You will be redirected to the Log In dialog.'; }
    get USER_SESSION_TIMEOUT_TITLE() { return 'Session Timeout'; }

}

// A singleton. Exports instance, not the class.
const textConstants = new TextConstants;
export default textConstants;